// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ski-media-inspection-rights.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ski-media-inspection-rights',
  title: 'Establish contractual right to inspect and confiscate removable media',
  description:
    'Contracts with employees and subcontractors working on government framework agreements must define ownership rights over information on removable media and grant the organisation the right to confiscate or inspect any media used in the delivery of services when there is a security concern.',
  category: 'assets',
  scfIds: ['SCF-AST-005'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Media ownership and inspection rights are documented in contracts/policies',
    },
    { type: 'document-approved', description: 'Policy has been approved' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
